import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from 'Store';

const selectSelf = (state: RootState) => state.breadcrumb;

export const selectBreadcrumbs = createSelector(selectSelf, state => state.breadcrumbs);

export const selectHasBreadcrumbs = createSelector(
  selectBreadcrumbs,
  breadcrumbs => breadcrumbs.length > 0
);

export const selectBreadcrumbCount = createSelector(
  selectBreadcrumbs,
  breadcrumbs => breadcrumbs.length
);

export const selectLastBreadcrumb = createSelector(
  selectBreadcrumbs,
  breadcrumbs => breadcrumbs[breadcrumbs.length - 1] ?? null
);

export const selectFirstBreadcrumb = createSelector(
  selectBreadcrumbs,
  breadcrumbs => breadcrumbs[0] ?? null
);

export const selectBreadcrumbsWithoutLast = createSelector(selectBreadcrumbs, breadcrumbs =>
  breadcrumbs.slice(0, -1)
);

export const selectIsOnHomePage = createSelector(
  selectBreadcrumbs,
  breadcrumbs => breadcrumbs.length <= 1
);

export const selectCurrentPageTitle = createSelector(
  selectLastBreadcrumb,
  lastBreadcrumb => lastBreadcrumb?.label ?? lastBreadcrumb?.translateKey ?? ''
);
